import React, { useEffect, useLayoutEffect, useState } from 'react';
import '../assets/customStyles/custom.css';
import '../assets/customStyles/projects.css';
import { Box as GBox } from 'grommet';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import expandIcon from '../assets/images/expand-icon.png'
import expandIconWhite from '../assets/images/expand-icon-white.png'
import projectsData from '../data/projects.json'
import  ProjectDetailsCard  from './ProjectDetailsCard'
import ProjectStackedCard from './ProjectStackedCard';
import CloseIcon from '@mui/icons-material/Close';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius:20
 
  //boxShadow: 24,
 // p: 4,
  
};

//light card orange : #fff
const Projects = () => {
  let [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useLayoutEffect(() => {
    function updateSize() {
      console.log(window.innerWidth)
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);



  let projects = JSON.parse(JSON.stringify(projectsData))
  const [open, setOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const handleOpen = (id) => {
    
    setModalData(projects[id-1])
    setOpen(true)
    console.log(projects[id - 1])
  };
  const handleClose = () => setOpen(false);

 
  


  return (
     <div style={{  display:'flex', flexDirection:'column', alignItems:'stretch', width:'80%',padding:20,paddingTop:50, paddingBottom:50}}>
       {open && 
      <Modal
       
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 200,
        }}
      >
        <Fade in={open}>
          <Box className='modal' sx={style}>
             <ProjectDetailsCard project={modalData}/>
              <div style={{position:'absolute',bottom:-20, left:'42%', borderRadius:100, display:'flex', width:50, height:50, justifyContent:'center', alignItems:'center'}}>
                <IconButton onClick={()=>setOpen(false)} style={{background:'rgb(204 41 41)'}}>
                 <CloseIcon color='#ff0000' style={{color:'#fff'}}/>
                </IconButton>
              </div>
          </Box>
        </Fade>
      </Modal>
      }
 <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>    
        <div style={{ height: 300, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', transform: (windowWidth >= 700 ? 'none' :  'rotate(90deg)') }}>

        <div style={{ display: 'flex' }}>
            <div className='card-1' onClick={() => handleOpen(1)} style={{ height: 320, width: 70, background: '#010029', borderTopLeftRadius: 20, borderBottomLeftRadius: 20, padding: 0, paddingLeft: 5, display: 'flex', flexDirection: 'column-reverse', justifyContent: 'space-between', textAlign: 'left', }}>
            <p className='project-card'>Recipe Box</p>
              <img width={40} height={40} alt='expand' src={expandIconWhite} />
          </div>
            <div className='card-2' onClick={() => handleOpen(2)} style={{ boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', color: '#000', width: 70, height: 320, background: '#fff', borderTopLeftRadius: 20, borderBottomLeftRadius: 20, padding: 0, paddingLeft: 5, marginLeft: -24, display: 'flex', flexDirection: 'column-reverse', justifyContent: 'space-between', textAlign: 'left' }}>
              <p className='project-card'>On The Menu</p>
            <img width={40} height={40} alt='expand' src={expandIcon} />
          </div>
            <div className='card-3' onClick={() => handleOpen(3)} style={{
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: 320, width: 70, background: '#010029', borderTopLeftRadius: 20, borderBottomLeftRadius: 20, padding: 0, paddingLeft: 5, marginLeft: -24, display: 'flex', flexDirection: 'column-reverse', justifyContent: 'space-between', textAlign: 'left' }}>
            <p className='project-card'>SpotiFacts</p>
              <img width={40} height={40} alt='expand' src={expandIconWhite} />
          </div>
            <div className='card-4' onClick={() => handleOpen(4)} style={{ boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: 320, width: 200, background: '#fff', borderRadius: 20, padding: 0, paddingLeft: 5, marginLeft: -24, display: 'flex', overflow: 'hidden', justifyContent: 'space-between', textAlign: 'left',color:'#000' }}>
            <div style={{ display: 'flex', flexDirection: 'column-reverse', justifyContent: 'space-between' }}>
            <p className='project-card'>Ellore</p>
              <img width={40} height={40} alt='expand' src={expandIcon} />
            </div>
            <div className="last-card card-5" style={{height: 320, borderLeft: '1px solid #000', textAlign:'left' }}>
                <p style={{ marginLeft: 18, marginRight: 8, fontSize: 20, transform: (windowWidth >= 700 ? 'none' : 'rotate(-90deg)') }}>Tap the cards to expand</p>
            </div>
          </div>
        </div>
      </div>
      </div>
      {// Cards End
      }




    <GBox  style={{ color: '#212121', width:'100%',display:'none'}}>
     

      <GBox style={{ justifyContent: 'space-evenly', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        <GBox animation="zoomIn" direction="column" style={{ alignItems: "center" }} >

          <GBox elevation='xlarge' direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "#fff", maxWidth: 300, height: 350, marginTop:10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 style={{ marginTop: 10, marginBottom: 2 }}>Recipe Box</h4>
              <div style={{ backgroundColor: '#fff', display: 'flex', borderRadius: 50, justifyContent: 'center', alignContent: 'center' }} >
                <img width={50} height={50} alt='recipe box' src={require("../assets/images/logoRecipeBox.png")} />
              </div>
            </div>
            <div style={{  display:'flex', flexWrap:'wrap', alignItems:'center', marginBottom:5,}}>
              <Chip style={{marginTop:5,marginRight:5}}  color='secondary' label='React Native'/>
              <Chip style={{ marginTop: 5, marginRight: 5}}  color='secondary' label='JavaScript' /> 
              <Chip style={{marginTop:5}}  color='secondary' label='Express' /> 
              <Chip style={{ marginTop: 5 }}  color='secondary' label='MySQL' /> 
            </div>
           
            <p style={{ textAlign: "left", margin: 2, fontSize: 16 }}>Cross platform app built using react-native supported by a back-end built with Node JS. App provides user's access to recipes around the world.</p>
         
          
            <div style={{ position: 'absolute', width: 275, bottom: 20, display: 'flex', backgroundColor: '#fe7027', borderRadius: 50, flexDirection: 'row', alignItems: 'center', justifyContent:'flex-end'}}>
              <div id='link-label' style={{position:'relative',width:10}}>
              <h5 style={{ fontSize: 14, margin: 5,position:'absolute', left:-50,top:-12 }}>Links</h5>
              </div>
              <div style={{ display: 'flex',width:'70%', backgroundColor: '#313131', borderRadius:50,justifyContent:'flex-end', alignItems:'flex-end'}}>
              <Button href="https://github.com/jatinAroraGit/recipe-box-api" style={{ color: "#a6dbc0", borderRadius: 20 }}>Back End</Button>
                <Button href="https://github.com/jatinAroraGit/recipe-box-v2" style={{ color: "#a6dbc0", borderRadius: 20 }}>Front End</Button>
              </div>
            </div>
          </GBox>
        </GBox>

        <GBox animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 10 }} >

          <GBox elevation='xlarge' direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "#fff", maxWidth: 300, height: 350 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 style={{ marginTop: 10, marginBottom: 2 }}>On The Menu</h4>
              <div style={{ backgroundColor: '#fff', display: 'flex', borderRadius: 50, justifyContent: 'center', alignContent: 'center', padding: 5 }} >
                <img width={42} height={42} alt='recipe box' src={require("../assets/images/otmFullFormLogo.png")} />
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='React' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='TypeScript' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='HTML' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='CSS' />
            </div>

            <p style={{ margin: 0, textAlign: "left", paddingLeft: 5, paddingRight: 5, fontSize: 16, }}>Responsive web application that searches through 1000s of recipes filtered by cuisines, diets and ingredients</p>
            <div style={{ position: 'absolute', width: 275, bottom: 20, display: 'flex', backgroundColor: '#fe7027', borderRadius: 50, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
              <div id='link-label' style={{ position: 'relative', width: 10 }}>
                <h5 style={{ fontSize: 14, margin: 5, position: 'absolute', left: -50, top: -12 }}>Links</h5>
              </div>
              <div style={{ display: 'flex', width: '70%', backgroundColor: '#313131', borderRadius: 50, justifyContent: 'flex-end', alignItems: 'flex-end' }}>
           
                <Button href="https://on-the-menu.vercel.app" style={{ color: "#a6dbc0" , borderRadius: 20 }}>Web App</Button>
                <Button href="https://github.com/jatinAroraGit/OnTheMenu" style={{ color: "#a6dbc0", borderRadius: 20 }}>Source Code</Button>
            </div>
            </div>
          
          </GBox>

        </GBox>
      </GBox>
      <GBox style={{ justifyContent: 'space-evenly', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        <GBox animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 10 }} >

          <GBox direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "#fff", height: 350, maxWidth: 300 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 style={{ marginTop: 10, marginBottom: 2 }}>SpotiFacts</h4>
              <div style={{ backgroundColor: '#fff', display: 'flex', borderRadius: 50, justifyContent: 'center', alignContent: 'center', padding: 5 }} >
                <img width={42} height={42} alt='recipe box' src={require("../assets/images/spotifactsLogo.png")} />
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='React' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='JavaScript' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='HTML' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='Styled Components' />
            </div>
            <p style={{ textAlign: "left", margin: 2, padding: 0, fontSize: 16 }}> Web App built using Spotify API and OAuth to connect and process spotify account to deliver an analysis of their profile and tracks they listen to.</p>
           
            <div style={{ position: 'absolute', width: 275, bottom: 20, display: 'flex', backgroundColor: '#fe7027', borderRadius: 50, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
              <div id='link-label' style={{ position: 'relative', width: 10 }}>
                <h5 style={{ fontSize: 14, margin: 5, position: 'absolute', left: -50, top: -12 }}>Links</h5>
              </div>
              <div style={{ display: 'flex', width: '70%', backgroundColor: '#313131', borderRadius: 50, justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <Button href="https://spotifacts.vercel.app" style={{ color: "#a6dbc0", borderRadius: 20 }}>Web App</Button>
                <Button href="https://github.com/jatinAroraGit/spotifacts-app" style={{ color: "#a6dbc0", borderRadius: 20 }}>Front End</Button>
            </div>
            </div>
          </GBox>
        </GBox>

        <GBox animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 10 }} >

          <GBox direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "#fff", height: 350, maxWidth: 300 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 style={{ marginTop: 10, marginBottom: 2 }}>Ellore</h4>
              <div style={{ backgroundColor: '#fff', display: 'flex', borderRadius: 50, justifyContent: 'center', alignContent: 'center', padding: 5 }} >
                <img width={42} height={42} alt='recipe box' src={require("../assets/images/logoEllore.png")} />
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='JavaScript' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='HTML' />
              <Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label='CSS' />
            </div>
            <p style={{ textAlign: "left", margin: 2, padding: 0, fontSize: 16 }}> Modern and responsive landing page built using classic JavaScript, CSS, SCSS and HTML</p>
           
            <div style={{ position: 'absolute', width: 275, bottom: 20, display: 'flex', backgroundColor: '#fe7027', borderRadius: 50, flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
              <div id='link-label' style={{ position: 'relative', width: 10 }}>
                <h5 style={{ fontSize: 14, margin: 5, position: 'absolute', left: -50, top: -12 }}>Links</h5>
              </div>
              <div style={{ display: 'flex', width: '70%', backgroundColor: '#313131', borderRadius: 50, justifyContent: 'flex-end', alignItems: 'flex-end' }}>
              <Button href="https://ellore.web.app" style={{ color: "#a6dbc0",borderRadius: 20 }}>Website</Button>
                <Button href="https://github.com/jatinAroraGit/ellore-landing-page" style={{ color: "#a6dbc0", borderRadius: 20 }}>Source Code</Button>
            </div>
            </div>
          </GBox>
        </GBox>
      </GBox>
    </GBox>
    </div>

  )

}

export default Projects